// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"OX6I5","breadcrumbsNavigation":"_3VdSj","carousel":"_1vwOP","scrollList":"_2UC8L"};